import request from "root/js/request";

//
export const getParsersCompanyFinancesLimits = async (params = {}) => {
  const response = await request({
    url: "/parsers/company_finances/limits/",
    method: "get",
    params,
  });

  return response.data;
};
